import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { authLogout } from '../../../store/actions/authActions';
import { getAllUsers } from "./getAllUsers";
import API from "../../../store/api";
import { clearUsers } from "../../../store/actions/usersActions";

export const deleteUser = (id, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.delete(`/api/portal/users/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAllUsers(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully deleted.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearUsers);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Delete User Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}